import MetricsCard from "../MetricsCard";
import { Flex, Box } from "@chakra-ui/react";
import { useMetrics } from "../../hooks/useMetrics";
import FullLoader from "core/components/Fullloader/FullLoader";
import { useTranslation } from "react-i18next";
import { ProbeType } from "modules/monitoring/ProbeList/schemas/formSchemas";
import RegionsFilter from "../RegionsFilter/RegionsFilter";
import { usePersistedState } from "../../hooks/usePersistedState";

const MetricsList = () => {
  const { t } = useTranslation();

  const [selectedRegions, setSelectedRegions] = usePersistedState(
    [],
    "filtersRegion"
  );

  const { data, isLoading } = useMetrics(true, selectedRegions);

  if (isLoading) {
    return <FullLoader />;
  }

  if (!data) {
    return <Box>{t("metrics.no_metrics")}</Box>;
  }

  return (
    <>
      <RegionsFilter
        selectedRegions={selectedRegions}
        setSelectedRegions={setSelectedRegions}
      />
      <Box>
        <Flex flexWrap="wrap" justifyContent="center" my={4}>
          {data.map((probe) => (
            <MetricsCard key={probe.id} metric={probe as ProbeType} />
          ))}
        </Flex>
      </Box>
    </>
  );
};

export default MetricsList;
